/**
 * @constant
 */
const SectorTypes = {
    MATING: 1,
    SOWS: 2,
    RENOVATION_SOWS: 3,
    DELIVERY: 4,
    BABY_ROOM: 5,
    PORK_HOUSE: 6,
    PIGLET_HOUSE: 7,
    BOAR_HOUSE: 8
};

module.exports = SectorTypes;
